import swal from 'sweetalert2'
import Rails from '@rails/ujs'

Rails.confirm = function (message, element) {
  const swalCustomStyle = swal.mixin({
    customClass: {
      confirmButton: 'btn btn--success',
      cancelButton: 'btn btn--link'
    },
    buttonsStyling: false
  })

  swalCustomStyle.fire({
    title: '¿Estas Seguro?',
    text: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Si, adelante!',
    cancelButtonText: 'Cancelar',
    reverseButtons: true
  }).then((result) => {
    if (result.value) {
      element.removeAttribute('data-confirm')
      element.click()
    }
  })
}

let toaster = swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', swal.stopTimer)
    toast.addEventListener('mouseleave', swal.resumeTimer)
  }
})

let sweetalert = swal.mixin({
  showConfirmButton: true
})

window.swal = swal
window.toaster = toaster
window.sweetalert = sweetalert
